import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportData";
import { WeightedPricesReportData } from "../types";

export const useWeightedPriceReportData = () => {
  const data = useSelector<StoreType, WeightedPricesReportData[] | undefined>(
    (s) => s.data.reports.exchbusiness.weightedPrice.data
  );

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  return [data, dispatchLoadData] as [typeof data, typeof dispatchLoadData];
};
